import React from "react";
import {Badge, Breadcrumb, Image, Tabs} from "antd";
import {UserOutlined} from "@ant-design/icons";
import logo from "@images/logo.png";
import avatar from "@images/photos/sherkhan.png";
import MyListComponent from "./my-list-component/MyListComponent";
import ChangePassword from "@components/me/change-password/ChangePassword";
import "./my-profile.scss";


const {TabPane} = Tabs;

const MyProfile = ({currentUser}) => {

    console.log(currentUser)

    const onChange = (key) => {
        console.log(key);
    };

    return (
        <>
            <div className="my-profile-page">
                <div className="breadcrumb">
                    <Breadcrumb
                        style={{
                            margin: '16px 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <UserOutlined/>
                            <span>Мой профиль</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="card-row">
                    <div className="team-card">
                        <div className="background-image"></div>
                        <div>
                            <img src={logo} alt="" className="logo-in-wallpaper"/>
                        </div>
                        <div className="content">
                            <div className="imgBx">
                                <Image src={avatar} width={90}/>
                            </div>
                            <div className="contentBox">
                                <h4>Шерхан Тулкибай</h4>
                                <h5>Главный специалист</h5>
                                <h5 style={{color: '#0e7490'}}>АИК</h5>
                                <h5>
                                    <Badge status="success"/>
                                    <span>На работе</span>
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div className="description-card">
                        <div className="description-tabs">
                            <div className="card-title">Мой профиль</div>
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Настройки" key="1">
                                    <ChangePassword />
                                </TabPane>
                                <TabPane tab="Выполненные задачи" key="2">
                                    <MyListComponent />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyProfile;
